import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const RedeemableSection = () =>
  <React.Fragment>
    <div className="referral-title">
      <h3>
        <FormattedMessage id="redeemablesection.title.how-it-works" defaultMessage="How to get your gift" />
      </h3>
    </div>
    <div className="brand-line my-3 mx-auto" />

    <div className="how-it-works-icons-container">
      <div className="referral-icon-container">
        <div className="referral-circle">
          <div className="step-icon">
            <img
              loading="lazy"
              src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/gift.svg"
              alt="Apply coupon"
            />
          </div>
        </div>
        <p className="referral-circle-title">
          <FormattedMessage id="redeemablesection.acceptyourgift" defaultMessage="Accept your gift" />
        </p>
        <p className="referral-circle-subtitle">
          <FormattedMessage
            id="redeemablesection.signup.subtitle"
            defaultMessage="When you accept this gift, you will be taken to the Account area where the applicable products will be available."
          />
        </p>
      </div>

      <div className="chevron-container">
        <FontAwesomeIcon icon={faChevronRight} className="referral-chevron" />
      </div>

      <div className="referral-icon-container">
        <div className="referral-circle">
          <div className="step-icon">
            <img
              loading="lazy"
              src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/box-download.svg"
              alt="Browse store"
            />
          </div>
        </div>
        <p className="referral-circle-title">
          <FormattedMessage id="redeemablesection.redeemyourkeys" defaultMessage="Redeem Your Keys" />
        </p>
        <p className="referral-circle-subtitle">
          <FormattedMessage
            id="redeemablesection.acceptyourgift.subtitle"
            defaultMessage="Within your Account you’ll be able to reveal your keys, which can be redeemed instantly."
          />
        </p>
      </div>

      <div className="chevron-container">
        <FontAwesomeIcon icon={faChevronRight} className="referral-chevron" />
      </div>

      <div className="referral-icon-container">
        <div className="referral-circle">
          <div className="step-icon cart-add">
            <img
              loading="lazy"
              src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/game-pad.svg"
              alt="Add to cart"
            />
          </div>
        </div>
        <p className="referral-circle-title">
          <FormattedMessage id="redeemablesection.enjoyyourgift" defaultMessage="Enjoy Your Gift" />
        </p>
        <p className="referral-circle-subtitle">
          <FormattedMessage
            id="redeemablesection.enjoyyourgift.subtitle"
            defaultMessage="That’s it! Get stuck in and enjoy hours of entertainment, courtesy of the lovely person who sent this to you!"
          />
        </p>
      </div>
    </div>
  </React.Fragment>;


export default RedeemableSection;
